/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconReceiptYuan = createReactComponent("outline", "receipt-yuan", "IconReceiptYuan", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M9 12h6", "key": "svg-1" }], ["path", { "d": "M9 7l3 4.5", "key": "svg-2" }], ["path", { "d": "M15 7l-3 4.5v4.5", "key": "svg-3" }]]);

export { IconReceiptYuan as default };
//# sourceMappingURL=IconReceiptYuan.mjs.map
